module.exports = __webpack_public_path__ + "static/media/folder.c03d98d0.svg";